<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-title>
            <div class="text-h6 font-weight-bold">Estadística de elementos</div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="4">
                  <v-row>
                    <v-col cols="12">
                      <div class="chart-container">
                        <div class="text-subtitle-1 font-weight-bold chart-title">Elementos por turno</div>
                        <apexchart width="100%" type="donut" :options="optionsTurno" :series="seriesTurno"></apexchart>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="chart-container">
                        <div class="text-subtitle-1 font-weight-bold chart-title">Elementos por tipo de función</div>
                        <apexchart
                          width="100%"
                          type="donut"
                          :options="optionsTipoFuncion"
                          :series="seriesTipoFuncion"
                        ></apexchart>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="chart-container">
                        <div class="text-subtitle-1 font-weight-bold chart-title">Elementos por estatus</div>
                        <apexchart
                          width="100%"
                          type="donut"
                          :options="optionsEstatus"
                          :series="seriesEstatus"
                        ></apexchart>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="8">
                  <div class="chart-container chart-container-large">
                    <div class="text-subtitle-1 font-weight-bold chart-title">Elementos por puesto</div>
                    <apexchart
                      ref="apex"
                      width="100%"
                      type="bar"
                      :options="optionsPuesto"
                      :series="seriesPuesto"
                    ></apexchart>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
/* Estilos modernos para Dashboard Recursos Humanos */
.card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

::v-deep .v-card-title {
  padding: 20px 24px;
  background: rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
}

::v-deep .v-card-text {
  padding: 24px;
}

.text-h6 {
  color: #e0e0e0 !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  font-size: 1.25rem !important;
}

/* Contenedores de gráficas con estilo moderno */
.chart-container {
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.15);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.chart-container:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.3);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.2);
  transform: translateY(-2px);
}

.chart-container-large {
  min-height: 600px;
}

.chart-title {
  color: var(--v-secondary-base) !important;
  margin-bottom: 16px;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.875rem !important;
  text-shadow: 0 2px 8px rgba(var(--v-secondary-base-rgb), 0.3);
}

/* Estilos para las gráficas ApexCharts */
::v-deep .apexcharts-canvas {
  background: transparent !important;
}

::v-deep .apexcharts-svg {
  border-radius: 12px;
}

::v-deep .apexcharts-text {
  fill: #e0e0e0 !important;
  font-family: 'Roboto', sans-serif !important;
}

::v-deep .apexcharts-legend-text {
  color: #e0e0e0 !important;
  font-weight: 500 !important;
}

::v-deep .apexcharts-legend-marker {
  border-radius: 4px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

::v-deep .apexcharts-datalabel-label,
::v-deep .apexcharts-datalabel-value {
  fill: #ffffff !important;
  font-weight: 700 !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

::v-deep .apexcharts-pie-label {
  fill: #ffffff !important;
  font-weight: 600 !important;
}

::v-deep .apexcharts-gridline {
  stroke: rgba(224, 224, 224, 0.08);
}

::v-deep .apexcharts-xaxis-label,
::v-deep .apexcharts-yaxis-label {
  fill: rgba(224, 224, 224, 0.9) !important;
  font-weight: 500 !important;
}

::v-deep .apexcharts-bar-area {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}

::v-deep .apexcharts-tooltip {
  background: rgba(26, 38, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
}

::v-deep .apexcharts-tooltip-title {
  background: rgba(0, 0, 0, 0.3) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  color: #e0e0e0 !important;
  font-weight: 600 !important;
}

::v-deep .apexcharts-tooltip-text-y-label,
::v-deep .apexcharts-tooltip-text-y-value {
  color: #e0e0e0 !important;
}

/* Scrollbar personalizado */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}

/* Animación de entrada */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import validator from 'validator'

export default {
  mounted() {
    this.setBarData()
  },

  data() {
    return {
      calendario: '',

      selectedOpen: false,
      selectedEvent: {},
      selectedElement: null,

      optionsEstatus: {
        chart: {
          type: 'donut',
          background: 'transparent',
        },
        theme: {
          mode: 'dark',
        },
        colors: [
          '#26de81',
          '#fed330',
          '#fc5c65',
          '#45aaf2',
          '#a55eea',
          '#fd9644',
          '#4b7bec',
          '#20bf6b',
          '#fa8231',
          '#eb3b5a',
        ],
        legend: {
          labels: {
            colors: '#e0e0e0',
          },
        },
        dataLabels: {
          style: {
            colors: ['#ffffff'],
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
        labels: [
          'Activos',
          'Acta administrativa',
          'Baja definitivia',
          'Franco / Vacaciones',
          'L.S.G.S.',
          'Suspendido',
          'Incapacidad',
          'Gravidez',
          'Permiso por maternidad',
          'L.C.G.S.',
        ],
      },

      optionsTurno: {
        chart: {
          type: 'donut',
          background: 'transparent',
        },
        theme: {
          mode: 'dark',
        },
        colors: ['#4b7bec', '#26de81', '#fed330', '#fc5c65'],
        legend: {
          labels: {
            colors: '#e0e0e0',
          },
        },
        dataLabels: {
          style: {
            colors: ['#ffffff'],
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
        labels: ['24 Hrs.', 'Turno A', 'Turno B', 'Sin turno asignado'],
      },

      optionsTipoFuncion: {
        chart: {
          type: 'donut',
          background: 'transparent',
        },
        theme: {
          mode: 'dark',
        },
        colors: ['#a55eea', '#45aaf2', '#26de81', '#fc5c65'],
        legend: {
          labels: {
            colors: '#e0e0e0',
          },
        },
        dataLabels: {
          style: {
            colors: ['#ffffff'],
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
        labels: ['Administrativa', 'Operativa', 'Operativa con funciones administrativas', 'Sin asignar'],
      },

      optionsPuesto: {
        chart: {
          id: 'vuechart-example',
          background: 'transparent',
          toolbar: {
            show: true,
            tools: {
              download: true,
            },
          },
        },
        theme: {
          mode: 'dark',
        },
        colors: ['#26de81'],
        xaxis: {
          name: 'Puesto',
          categories: [],
          labels: {
            style: {
              colors: '#e0e0e0',
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: '#e0e0e0',
            },
          },
        },
        grid: {
          borderColor: 'rgba(224, 224, 224, 0.1)',
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#ffffff'],
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            horizontal: true,
            distributed: false,
            dataLabels: {
              position: 'top',
            },
          },
        },
      },

      seriesPuesto: [
        {
          name: 'Puesto',
          data: [],
        },
      ],
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonal',
    }),

    ...mapGetters('puesto', {
      puestos: 'getPuestos',
    }),

    seriesEstatus() {
      var seriesEstatus = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      this.personal.forEach((personal) => {
        switch (personal.fk_idEstatus) {
          case 1:
            seriesEstatus[0]++
            break
          case 2:
            seriesEstatus[1]++
            break
          case 3:
            seriesEstatus[2]++
            break
          case 4:
            seriesEstatus[3]++
            break
          case 10:
            seriesEstatus[4]++
            break
          case 11:
            seriesEstatus[5]++
            break
          case 12:
            seriesEstatus[6]++
            break
          case 14:
            seriesEstatus[7]++
            break
          case 15:
            seriesEstatus[8]++
            break
          case 16:
            seriesEstatus[9]++
            break

          default:
            break
        }
      })

      return seriesEstatus
    },

    seriesTurno() {
      var seriesTurno = [0, 0, 0, 0]

      this.personal.forEach((personal) => {
        switch (personal.fk_idCatTurno) {
          case 1:
            seriesTurno[0]++
            break
          case 2:
            seriesTurno[1]++
            break
          case 3:
            seriesTurno[2]++
            break
          default:
            seriesTurno[3]++
            break
        }
      })

      return seriesTurno
    },

    seriesTipoFuncion() {
      var seriesTipoFuncion = [0, 0, 0, 0]

      this.personal.forEach((personal) => {
        switch (personal.fk_idCatTipoFuncion) {
          case 1:
            seriesTipoFuncion[0]++
            break
          case 2:
            seriesTipoFuncion[1]++
            break
          case 3:
            seriesTipoFuncion[2]++
            break
          default:
            seriesTipoFuncion[3]++
            break
        }
      })

      return seriesTipoFuncion
    },
  },

  methods: {
    setBarData: function () {
      var listaPuestos = []
      var cantidadPorPuesto = []

      this.puestos.forEach((puesto) => {
        if (this.personal.some((personal) => personal.fk_idPuestoDependencia == puesto.fk_idPuesto)) {
          cantidadPorPuesto.push(
            this.personal.filter((personal) => {
              return personal.fk_idPuestoDependencia == puesto.fk_idPuesto
            }).length
          )
          listaPuestos.push(puesto.catPuesto.puesto)
        }
      })

      this.optionsPuesto = {
        ...this.optionsPuesto,
        ...{
          xaxis: {
            categories: listaPuestos,
          },
        },
      }

      this.$refs.apex.updateSeries([{ name: 'Cantidad de elementos', data: cantidadPorPuesto }])
    },
  },
}
</script>
